export default {
  id: undefined,
  type: 'service_tax',
  attributes: {
    name: 'Sales Tax',
    description: '',
    percent: 5,
    priority: 0,
    service_id: null,
  },
}
